import React, {useState} from "react";
import {Col, Popover, PopoverBody, Row, Table, UncontrolledTooltip} from "reactstrap";

import {
  getAzureDisplayName,
  getDatadogName,
  getNRDisplayName,
  getStateSpecificAWSLogo,
  getStateSpecificAzureLogo,
  getStateSpecificDatadogLogo,
  getStateSpecificGCPLogo,
  getStateSpecificNRLogo,
  getStateSpecificADLogo,
  getAppDynamicsName,
  getAppDynamicsLogo,
  getSplunkName,
  getStateSpecificSplunkLogo,
  getDynatraceName,
  getDynatraceLogo, getOciName, getOciLogo, getGrafanaLogo, getSignozLogo
} from '../../helpers/component_helpers';

import {Link} from 'react-router-dom';
import "../Resources/style.scss"

const ResourcesTable = ({resources, getNotificationServiceMapping, type, height, maxHeight}) => {
  const [popoverText, setPopoverText] = useState('')
  const [popoverOpen, setPopoverOpen] = useState({});
  const [typePopoverOpen, setTypePopoverOpen] = useState({});
  const [typePopoverText, setTypePopoverText] = useState({});
  const [environmentPopoverText, setEnvironmentPopoverText] = useState({});
  const [environmentPopoverOpen, setEnvironmentPopoverOpen] = useState({});
  const [iconPopoverOpen, setIconPopoverOpen] = useState({});
  const [iconPopoverText, setIconPopoverText] = useState('');


  const togglePopover = (key, isOpen) => {
    setPopoverOpen(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };

  const handleMouseEnter = (key, name) => {
    setPopoverText(name);
    togglePopover(key, true);
  };

  const handleMouseLeave = (key) => {
    togglePopover(key, false);
  };
  const togglePopoverIcon = (key, isOpen) => {
    setIconPopoverOpen(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };

  const handleMouseEnterIcon = (key, name) => {
    setIconPopoverText(name);
    togglePopoverIcon(key, true);
  };

  const handleMouseLeaveIcon = (key) => {
    togglePopoverIcon(key, false);
  };

  const handleTypeMouseEnter = (resourceId, type) => {
    setTypePopoverText(prevState => ({
      ...prevState,
      [resourceId]: type,
    }));
    setTypePopoverOpen(prevState => ({
      ...prevState,
      [resourceId]: true,
    }));
  };

  const handleTypeMouseLeave = (resourceId) => {
    setTypePopoverOpen(prevState => ({
      ...prevState,
      [resourceId]: false,
    }));
  };

  const handleEnvMouseEnter = (key, name) => {
    setEnvironmentPopoverText(name);
    setEnvironmentPopoverOpen(prevState => ({
      ...prevState,
      [key]: true,
    }));
  };

  const handleEnvMouseLeave = (key) => {
    setEnvironmentPopoverOpen(prevState => ({
      ...prevState,
      [key]: false,
    }));
  };

  const copyToClipboard = (textToCopy) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(textToCopy)
        .then(() => toastr.success("Copied!"))
        .catch(err => console.error('Could not copy text: ', err));
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        toastr.success("Copied!");
      } catch (err) {
        console.error('Could not copy text: ', err);
      }
      document.body.removeChild(textarea);
    }
  };

  return (
    <React.Fragment>
      {(resources) &&
        <div style={{height: height, overflowY: "hidden", overflowX: "hidden", maxHeight: maxHeight}}>
          <Table className="w-100">
          
            <div className="justify-content-center translucent-nav text-white">
            <Row style={{height: "50px"}} className="justify-content-center bg-transparent">
              <Col lg={3} className="text-center py-3 bg-transparent text-white">
                Resource Name
              </Col>
              <Col lg={1} className="text-center py-3 bg-transparent text-white">
                Type
              </Col>
              <Col lg={2} className="text-center py-3 bg-transparent text-white">
                Environment
              </Col>
              <Col lg={2} className="text-center py-3 ps-2 bg-transparent text-white">
                Alert Health
              </Col>
              <Col lg={2} className="text-center py-3 bg-transparent text-white">
                Application service
              </Col>
              <Col lg={2} className="text-center py-3 bg-transparent text-white">
                Actions
              </Col>
            </Row>
            </div>
            {
              (resources && Object.entries(resources)?.length > 0) ? Object.keys(resources)?.map((key, index) => (
                <Row key={index} className="justify-content-start" style={{borderBottom: "1px solid #696283"}}>
                  <Col lg={3} className="text-center mt-2">
                    <div className="d-flex" style={{backgroundColor: "transparent"}}>
                      <Col lg={3} className="text-start">
                        <img style={{width: "28px", marginRight: "5px"}}
                             src={type === 'AWS' ? getStateSpecificAWSLogo(resources[key]?.resource_name) :
                               (type === 'GCP' ? getStateSpecificGCPLogo(resources[key]?.resource_name) :
                                (type === 'NewRelic' ? getStateSpecificNRLogo(resources[key]?.resource_name) :
                                  (type === 'Datadog' ? getStateSpecificDatadogLogo(resources[key]?.resource_name) :
                                    (type === 'AppDynamics' ? getAppDynamicsLogo(resources[key]?.resource_name, true) :
                                      (type === 'Dynatrace' ? getDynatraceLogo(resources[key]?.resource_name, true) :
                                        (type === 'Splunk' ? getStateSpecificSplunkLogo(resources[key]?.resource_name, true) :
                                          (type === 'OCI' ? getOciLogo(resources[key]?.resource_name) :
                                            (type === 'Grafana' ? getGrafanaLogo(resources[key]?.resource_name) :
                                              (type === 'Signoz' ? getSignozLogo(resources[key]?.resource_name) :
                                                (type === 'Temperstack' ? 'https://prod-temperstack-public-assets.s3.ap-south-1.amazonaws.com/temperstack-logos/temperstack-emblem.png' :
                                                getStateSpecificAzureLogo(resources[key]?.resource_name)))))))))))}/>
                      </Col>
                      <Col lg={9} className="d-flex-row text-start">
                        <Link to={
                          type === "AWS" ? `/resource/${resources[key].id}/alerts` :
                            type === "GCP" ? `/gcp/resource/${resources[key].id}/alerts` :
                              type === 'Azure' ? `/azure/resource/${resources[key].id}/alerts` :
                                type === 'NewRelic' ? `/newrelic/resource/${resources[key].id}/alerts` :
                                  type === 'AppDynamics' ? `/appdynamics/resource/${resources[key].id}/alerts` :
                                    type === 'Splunk' ? `/splunk/resource/${resources[key].id}/alerts` :
                                        type === 'Temperstack' ? `/ping-monitoring?endpoint_id=${resources[key].id}` :
                                          type === 'Dynatrace' ? `/dynatrace/resource/${resources[key].id}/alerts` :
                                            type === 'OCI' ? `/oci/resource/${resources[key].id}/alerts` :
                                              type === 'Grafana' ? `/grafana/resource/${resources[key].id}/alerts` :
                                                type === 'Signoz' ? `/signoz/resource/${resources[key].id}/alerts` :

                                        `/datadog/resource/${resources[key]?.id}/alerts`
                        }
                              id={`resource-link-${resources[key]?.id}`}
                              style={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                display: "inline-block"
                              }}
                              onMouseEnter={() => handleMouseEnter(key, resources[key].name)}
                              onMouseLeave={() => handleMouseLeave(key)}
                        >
                          {resources[key]?.name || resources[key]?.endpoint_name}
                        </Link>
                        <Popover isOpen={popoverOpen[key] || false} target={`resource-link-${resources[key]?.id}`} placement="top">
                          <PopoverBody>{popoverText}</PopoverBody>
                        </Popover>
                        {type !== 'Temperstack' ?
                        (<div className="d-flex gap-1 mt-1">
                          <div style={{
                            fontSize: "11px",
                            color: "white",
                            width: "100%",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            display: "inline-block"
                          }}>
                            {resources[key].cloud_reference_id || resources[key].newrelic_reference_id || resources[key].datadog_reference_id || resources[key].appdynamics_reference_id||resources[key].splunk_reference_id || resources[key].dynatrace_reference_id ||resources[key].alerts.id || resources[key].grafana_reference_id || resources[key].signoz_reference_id  }
                          </div>

                          <i className="bx bx-copy"
                             style={{cursor: 'pointer', width: '15px', height: '15px', color: "white"}}
                             onClick={() => {
                               copyToClipboard(resources[key].cloud_reference_id ||
                                 resources[key].newrelic_reference_id ||
                                 resources[key].datadog_reference_id || resources[key].appdynamics_reference_id ||resources[key].splunk_reference_id || resources[key].dynatrace_reference_id || resources[key].grafana_reference_id);
                             }} id={`cloudId-${index}`}>
                          </i>
                          <UncontrolledTooltip placement="top" target={`cloudId-${index}`}>Copy</UncontrolledTooltip>
                        </div>): null}
                      </Col>
                    </div>
                  </Col>
                  <Col lg={1}>
                    <div
                      className="text-center mt-2"
                      id={`type-link-${key}-${resources[key]?.id}`}
                      onMouseEnter={() => handleTypeMouseEnter(resources[key]?.id, resources[key].resource_name)}
                      onMouseLeave={() => handleTypeMouseLeave(resources[key]?.id)}
                      style={{
                        backgroundColor: "transparent",
                        width: "100%",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        display: "inline-block"
                      }}>
                      {type === "AWS" ? resources[key]?.resource_name?.replace('AWS/', '') :
                        type === "GCP" ? resources[key]?.resource_name :
                          type === 'NewRelic' ? getNRDisplayName(resources[key]?.resource_name) :
                            type === 'Azure' ? getAzureDisplayName(resources[key]?.resource_name) :
                              type === 'AppDynamics' ? getAppDynamicsName(resources[key]?.resource_name) :
                                 type === 'Dynatrace'? getDynatraceName(resources[key]?.resource_name) :
                                  type === 'Splunk' ? getSplunkName(resources[key]?.resource_name) :
                                    type === 'OCI' ? getOciName(resources[key]?.resource_name) :
                                      type === 'Temperstack' ? 'Synthetics' :
                                        getDatadogName(resources[key]?.resource_name)}
                    </div>
                    <Popover
                      isOpen={typePopoverOpen[resources[key]?.id] || false}
                      target={`type-link-${key}-${resources[key]?.id}`}
                      placement="top">
                      <PopoverBody>
                        {type === "AWS" ? typePopoverText[resources[key]?.id]?.replace('AWS/', '') :
                          type === "GCP" ? typePopoverText[resources[key]?.id] :
                            type === 'NewRelic' ? getNRDisplayName(resources[key].resource_name) :
                              type === 'Azure' ? getAzureDisplayName(resources[key].resource_name) : 
                                type === 'AppDynamics' ? getAppDynamicsName(resources[key].resource_name) :
                                  type === 'Dynatrace' ? getDynatraceName(resources[key].resource_name) :
                                    type === 'Splunk' ? getSplunkName(resources[key]?.resource_name) :
                                        type === 'OCI'? getOciName(resources[key]?.resource_name) :
                                      type === 'Temperstack' ? 'Synthetics' :
                                        getDatadogName(resources[key].resource_name)}</PopoverBody>
                    </Popover>
                  </Col>

                  <Col lg={2}>
                    <div
                      className="mt-2 text-center w-100"
                      style={{backgroundColor: "transparent"}}
                      id={`env-link-${key}-${resources[key]?.id}`}
                      onMouseEnter={() => handleEnvMouseEnter(resources[key]?.id, resources[key].environment)}
                      onMouseLeave={() => handleEnvMouseLeave(resources[key]?.id)}>
                      {resources[key]?.environment || "Production"}
                    </div>

                    <Popover
                      isOpen={environmentPopoverOpen[key] || false}
                      target={document.getElementById(`env-link-${key}-${resources[key]?.id}`) ? `env-link-${key}-${resources[key]?.id}` : null}
                      placement="top">
                      <PopoverBody>
                        {environmentPopoverText || "Production"}
                      </PopoverBody>
                    </Popover>
                  </Col>
                  <Col lg={2} className="text-center">
                    <div className="d-flex-row" style={{backgroundColor: "transparent"}}>
                      <div
                        className={`m-1 ${(resources[key]?.missing_alerts?.length) == 0 ? 'text-success' : 
                          ((resources[key]?.missing_alerts?.length > 0 && resources[key]?.alerts?.length > 0) ? 'text-warning': 'text-danger'
                      )}`}
                        style={{backgroundColor: "transparent"}}>
                        {resources[key]?.missing_alerts?.length } missing
                      </div>
                      <div className="m-0" style={{backgroundColor: "transparent"}}>
                        {resources[key]?.alerts?.length } setup
                      </div>
                    </div>
                  </Col>

                  <Col lg={2} className="text-center mt-1">
                    {getNotificationServiceMapping(resources[key]) || resources[key]?.application_service_name}
                  </Col>

                  <Col lg={1} className="text-center ms-5">
                    <div className="d-flex gap-2 bg-transparent">
                      <Link className="bg-transparent"
                            to={
                              type === "AWS" ? `/resource/${resources[key].id}/alerts` :
                                type === "GCP" ? `/gcp/resource/${resources[key].id}/alerts` :
                                  type === 'Azure' ? `/azure/resource/${resources[key].id}/alerts` :
                                    type === 'NewRelic' ? `/newrelic/resource/${resources[key].id}/alerts` :
                                      type === 'Grafana' ? `/grafana/resource/${resources[key].id}/alerts`:
                                        type === 'AppDynamics' ? `/appdynamics/resource/${resources[key].id}/alerts` :
                                          type === 'Dynatrace' ? `/dynatrace/resource/${resources[key].id}/alerts` :
                                            type === 'Splunk' ? `/splunk/resource/${resources[key].id}/alerts` :
                                              type === 'Temperstack' ? `/edit-endpoint` :
                                                type === 'OCI' ? `/oci/resource/${resources[key].id}/alerts` :
                                                  type === 'Signoz' ? `/signoz/resource/${resources[key].id}/alerts`:
                                          `/datadog/resource/${resources[key]?.id}/alerts`
                            }
                      state={{endpointId: resources[key]?.id}}
                      >
                        <i className="mdi mdi-pencil font-size-24 text-success" id={`edittooltip-${index}`}/>
                        <UncontrolledTooltip className="" placement="top" target={`edittooltip-${index}`}>
                          Config Alerts
                        </UncontrolledTooltip>
                      </Link>
                      {type !== 'Temperstack' ? (
                          resources[key]?.environment === 'PRODUCTION' ? (
                              resources[key]?.deployment_stage === 'deployment_required' ? (
                                  <a
                                      className="bg-transparent"
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        startLoading2();
                                        handleIndividualDeploy(resources[key]?.id);
                                      }}
                                      id={`deploymenttooltip-${index}`}
                                  >
                                    <i className="mdi mdi-cloud-sync font-size-24" />
                                    <UncontrolledTooltip className="tooltip-component" placement="top" target={`deploymenttooltip-${index}`}>
                                      Deploy Alerts
                                    </UncontrolledTooltip>
                                  </a>
                              ) : (
                                  <Link to="#" className="text-success bg-transparent">
                                    <i className="mdi mdi-cloud-check font-size-24" id={`deploymenttooltip-${index}`} />
                                    <UncontrolledTooltip placement="top" target={`deploymenttooltip-${index}`}>
                                      In Sync
                                    </UncontrolledTooltip>
                                  </Link>
                              )
                          ) : (
                              <Link to="#" className="text-muted">
                                <i className="mdi mdi-cloud-lock font-size-24" id={`deploymenttooltip-${index}`} />
                                <UncontrolledTooltip placement="top" target={`deploymenttooltip-${index}`}>
                                  Deployments disabled for non-production resources
                                </UncontrolledTooltip>
                              </Link>
                          )
                      ) : null}

                      {type !== 'Temperstack' &&
                      resources[key]?.resource_name === 'AWS/EC2' &&
                      JSON.parse(resources[key].resource_metadata) &&
                      JSON.parse(resources[key].resource_metadata).hasOwnProperty('cw_agent_installed') &&
                      JSON.parse(resources[key].resource_metadata).hasOwnProperty('cw_agent_enabled') &&
                      JSON.parse(resources[key].resource_metadata).cw_agent_enabled === true &&
                      JSON.parse(resources[key].resource_metadata).cw_agent_installed === false ? (
                          <div
                              id={`cw_agent_not_installed_${resources[key]?.id}`}
                              onMouseEnter={() => handleMouseEnterIcon(key, 'CloudWatch Agent not installed')}
                              onMouseLeave={() => handleMouseLeaveIcon(key)}
                              style={{position: 'relative', right: 0}}
                          >
                            <i className="mdi mdi-alert blinking-icon"/>
                            <Popover
                                isOpen={iconPopoverOpen[key] || false}
                                target={`cw_agent_not_installed_${resources[key]?.id}`}
                                placement="top"
                            >
                              <PopoverBody>{iconPopoverText}</PopoverBody>
                            </Popover>
                          </div>
                      ) : null}
                    </div>
                  </Col>
                </Row>
              )) : <div className="w-100 justify-content-center mt-5" style={{fontSize: "1rem"}}>
                <div className="text-center"> No resources found</div>
              </div>
            }
          </Table>
        </div>
      }

    </React.Fragment>)
}

export default ResourcesTable;
